import { Loading } from 'pages/loading/ui/loading.page';
import React from 'react';
import { useParams } from 'react-router-dom';
import { CreateAdministratorForm, Header } from 'widgets';
import { PageLayout } from 'shared/ui';

export const CreateAdministratorPage: React.FC = () => {
  const { id } = useParams();

  return id ? (
    <PageLayout>
      <Header />
      <CreateAdministratorForm businessId={id} />
    </PageLayout>
  ) : (
    <Loading />
  );
};
